type RequestMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

interface Request {
  url: string
  body?: string
  method?: RequestMethod
  accessToken?: string
  responseType?: string
  slug?: string
  contentType?: string
  headers?: any
}

interface PDFCreation {
  blob?: any | undefined
  title: string
  format?: string | undefined
  urlString?: string | undefined
}

export function getDocumentAndDownload({
  blob = undefined,
  title,
  format = undefined,
  urlString = ''
}: PDFCreation) {
  const url = blob ? URL.createObjectURL(blob) : urlString
  const downloadObject = document.createElement('a')
  downloadObject.href = url
  downloadObject.download = format ? `${title}.${format}` : title
  document.body.appendChild(downloadObject)
  downloadObject.click()
  downloadObject.remove()
}

export async function apiCall({
  url,
  method = 'GET',
  body,
  accessToken,
  responseType = 'json',
  slug = '',
  headers = {
    Authorization: 'Bearer ' + accessToken,
    'Content-Type': 'application/json'
  }
}: Request) {
  return await fetch(`${process.env.REACT_APP_API_URL}` + url, {
    method,
    body,
    headers
  }).then(async (response) => {
    switch (responseType) {
      case 'pdf':
      case 'docx':
        return await response.blob()
      case 'json':
        return await response.json()
      case 'text':
        return await response.text()
      default:
        return response
    }
  })
}
